import { render, staticRenderFns } from "./MarketImageCard.vue?vue&type=template&id=6367540b&"
import script from "./MarketImageCard.vue?vue&type=script&lang=js&"
export * from "./MarketImageCard.vue?vue&type=script&lang=js&"
import style0 from "./MarketImageCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports